import React from 'react';
import classes from "./BlacklistConfirmationModal.module.css";
import Spinner from './Spinner';
import { useTranslation } from 'react-i18next';

const UnsubConfirmationModal = ({setModal, msisdn ,unsubMsisdn , unsubLoading }) => {
  const { t } = useTranslation();

  return (
      <div className={classes.container} onClick={() => setModal(false)}>
            <div className={classes.sub_container} onClick={(e) => e.stopPropagation()}>
                <div className={classes.info}>
                    <img
                        src="/assets/images/warning.png"
                        alt="warning"
                        className={classes.img}
                    />
                </div>
                <div className={classes.msg}>
                    <p className={classes.text}>{t('unsubscription.modalTitle', { msisdn })}
                    </p>
                    <p className={classes.text}>{t('unsubscription.modalMessage')}</p>
                </div>
                <div className={classes.btns_container}>
                    <button className={classes.btn} type="button"
                    disabled={unsubLoading}
                    onClick={unsubMsisdn}
                    >
                        {unsubLoading ? <Spinner /> : t('common.yes')}
                    </button>
                    <button
                        className={classes.btn_2}
                        type="button"
                        disabled={unsubLoading}
                        onClick={()=>setModal(false)}
                    >
                        {t('common.no')}
                    </button>
                </div>
            </div>
        </div>
  )
}

export default UnsubConfirmationModal
